import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = { class: "h-100 d-flex g-tab-control flex-column" };
const _hoisted_2 = { class: "d-flex flex-row p-2 px-3 border-bottom bg-light" };
const _hoisted_3 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("ul", {
                class: _normalizeClass(['nav nav-pills w-100 gap-2', _ctx.justified ? 'nav-justified' : ''])
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx._pages, (page, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                        style: { "min-width": "80px" },
                        class: _normalizeClass(['nav-item text-center', index === 0 ? '' : '']),
                        key: page.title
                    }, [
                        _createElementVNode("a", {
                            class: _normalizeClass(['nav-link border text-truncate px-2', _ctx.isActivePage(page.name) ? 'active border-secondary' : '']),
                            style: { "padding": "0.2rem" },
                            href: "#",
                            onClick: _withModifiers(($event) => (_ctx._activePage = page.name), ["stop", "prevent"])
                        }, _toDisplayString(page.title), 11, _hoisted_3)
                    ], 2));
                }), 128))
            ], 2)
        ]),
        _renderSlot(_ctx.$slots, "default"),
        _createElementVNode("footer", null, [
            _renderSlot(_ctx.$slots, "footer")
        ])
    ]));
}
